/**
 * 검색엔진·공유 미리보기용 머리말.
 *
 * `index.html`에 박아 둔 것은 **서비스 공통 값**이다. 카카오톡·슬랙 같은
 * 미리보기 수집기는 자바스크립트를 돌리지 않으므로, 링크를 붙여 넣었을 때
 * 보이는 것은 언제나 그 정적 값이다(프로필마다 다른 미리보기는 SPA로는
 * 안 된다 — README 참조).
 *
 * 여기서 하는 일은 **구글에게 정본 주소를 알려주는 것**이다. 구글은
 * 자바스크립트를 돌리므로 여기서 바꾼 것을 읽는다.
 */

const SITE = 'https://life-timeline.com';

/**
 * 이 화면의 **정본 주소**.
 *
 * 없으면 `?lang=en`·`?tab=picks`가 붙은 주소가 저마다 다른 문서로 색인되어,
 * 같은 프로필이 검색 결과에 여러 줄로 갈린다. 쿼리를 떼고 경로만 정본으로
 * 못 박는다.
 */
export function setCanonical(path: string): void {
  const href = `${SITE}${path}`;
  let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (link === null) {
    link = document.createElement('link');
    link.rel = 'canonical';
    document.head.appendChild(link);
  }
  link.href = href;
}

/*
 * ⚠️ 설명 줄(`description`)과 `og:*`는 **`index.html`에 한 벌만 둔다.**
 *
 * 화면마다 바꿔 보려다 되돌렸다. 바꿔도 읽는 쪽이 거의 없다 — 수집기는
 * 자바스크립트를 안 돌리고, 돌리는 건 구글뿐인데 그 한 곳을 위해 "화면마다
 * 다른 값이 있다"는 착각을 코드에 남기게 된다. 한 벌이면 자바스크립트를
 * 안 돌리는 검색엔진(네이버·다음)도 **어느 주소로 들어오든** 서비스가
 * 무엇인지 읽는다.
 *
 * 여기서 화면마다 바꾸는 것은 **정본 주소뿐**이다. 그건 값이 아니라
 * "이 주소가 그 주소와 같은 문서다"라는 말이라, 주소마다 달라야 뜻이 산다.
 */
